'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AlbumItem2 = require('../AlbumItem');

var _AlbumItem3 = _interopRequireDefault(_AlbumItem2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _audioplayer = require('redux/modules/audioplayer');

var audioplayerActions = _interopRequireWildcard(_audioplayer);

var _playlists = require('redux/modules/playlists');

var playlistsActions = _interopRequireWildcard(_playlists);

var _reactRouterRedux = require('react-router-redux');

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _AlbumPlayPauseButton = require('../AlbumPlayPauseButton/AlbumPlayPauseButton');

var _AlbumPlayPauseButton2 = _interopRequireDefault(_AlbumPlayPauseButton);

var _AlbumItemThumb = require('../AlbumItemThumb/AlbumItemThumb');

var _AlbumItemThumb2 = _interopRequireDefault(_AlbumItemThumb);

var _AlbumMenuButton = require('../AlbumMenuButton/AlbumMenuButton');

var _AlbumMenuButton2 = _interopRequireDefault(_AlbumMenuButton);

var _AlbumItemInfo = require('../AlbumItemInfo/AlbumItemInfo');

var _AlbumItemInfo2 = _interopRequireDefault(_AlbumItemInfo);

var _AlbumItemSystemInfo = require('../AlbumItemSystemInfo/AlbumItemSystemInfo');

var _AlbumItemSystemInfo2 = _interopRequireDefault(_AlbumItemSystemInfo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./AlbumListItem.scss');

var cn = _bind2.default.bind(styles);

var AlbumListItem = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    playerAlbum: state.audioplayer.album,
    playerStatus: state.audioplayer.playerStatus,
    pressLoading: state.playlists.pressLoading
  };
}, (0, _extends3.default)({}, playlistsActions, { playAlbum: audioplayerActions.playAlbum, pushState: _reactRouterRedux.push })), _dec(_class = (_temp = _class2 = function (_AlbumItem) {
  (0, _inherits3.default)(AlbumListItem, _AlbumItem);

  function AlbumListItem() {
    (0, _classCallCheck3.default)(this, AlbumListItem);
    return (0, _possibleConstructorReturn3.default)(this, (AlbumListItem.__proto__ || (0, _getPrototypeOf2.default)(AlbumListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlbumListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          album = _props.album,
          coloredInfo = _props.coloredInfo,
          tracks = _props.tracks;


      return _react2.default.createElement(
        'div',
        { className: 'col-xs-60' },
        _react2.default.createElement(
          'div',
          { className: styles.album, onClick: this.gotoAlbum },
          _react2.default.createElement(_Loader2.default, { show: loading, mask: true }),
          _react2.default.createElement(
            'div',
            { className: styles.albumContent },
            _react2.default.createElement(
              'div',
              { className: styles.cover },
              _react2.default.createElement(
                'div',
                { className: 'ratio-cont' },
                _react2.default.createElement(_AlbumItemThumb2.default, { album: album, className: styles.coverImg }),
                _react2.default.createElement(_AlbumPlayPauseButton2.default, {
                  album: album,
                  tracks: tracks,
                  onClick: this.playPause
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.infoContainer },
              _react2.default.createElement(
                'div',
                { className: styles.info },
                _react2.default.createElement(_AlbumItemInfo2.default, {
                  album: album,
                  artistClass: styles.artistName,
                  overflow: true
                }),
                _react2.default.createElement(
                  'div',
                  { className: cn('albumType', album.audiovideo) },
                  album.audiovideo
                )
              ),
              _react2.default.createElement(_AlbumItemSystemInfo2.default, {
                className: styles.system,
                album: album,
                coloredInfo: coloredInfo,
                overflow: true
              })
            )
          ),
          _react2.default.createElement(_AlbumMenuButton2.default, {
            album: album,
            className: styles.menuButton,
            iconClass: 'more',
            onPlay: this.playPause,
            onDownloadPress: this.downloadPress,
            onDelete: this.deleteAlbum
          })
        )
      );
    }
  }]);
  return AlbumListItem;
}(_AlbumItem3.default), _class2.propTypes = {
  album: _propTypes2.default.object,
  coloredInfo: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  pushState: _propTypes2.default.func,
  t: _propTypes2.default.func,
  tracks: _propTypes2.default.object
}, _class2.defaultProps = {
  album: {},
  tracks: {}
}, _temp)) || _class);
exports.default = AlbumListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumItem/AlbumListItem/AlbumListItem.js
// module id = 1947
// module chunks = 1